
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
      getSpeakerEmotionList: `get /apis/baohuo-yuanchuang/v1/speaker/getSpeakerEmotionList`, // 获取所有风格 含该风格的表情包
      getStyleList: `get /apis/baohuo-yuanchuang/video/style/page`,//获取视频风格
      getRatioList: `get /apis/baohuo-yuanchuang/video/ratio/list`,//获取所有比例
      getEffectList:`get /apis/baohuo-yuanchuang/video/effect/list`,//获取效果
      submitCreate: `post /apis/baohuo-yuanchuang/oneClick/article/submit`, // 提交视频制作
      getDefaultSpeaker:`get /apis/baohuo-yuanchuang/speaker/store/search`,//获取默认发音人-魔天轮
      sensitiveWordCheck:`post /apis/baohuo-yuanchuang/thirdPart/sensitive/check`, //检测敏感词
			// 获取生成次数权益
			queryMemberLeftRight:'get /apis/baohuo-account/v1/memberCenter/queryMemberLeftRight',
			articleDetail: `get /apis/baohuo-yuanchuang/oneClick/article/detail?_from=INNER`,
			getWordLimit: `get /apis/baohuo-yuanchuang/oneClick/article/wordLimit`,

			// 获取小说推文内容文本
			getNovelDetail: `get /apis/baohuo-yuanchuang/compose/resource/detail`,
			// 获取最近一文章信息
			getLastArticleInfo: 'get /apis/baohuo-yuanchuang/oneClick/article/getLastArticleInfo'
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"textToVideoPage"
			})
		}